import * as React from "react";
import { useWatch } from "react-hook-form";

import { type TriggerTemplateCatalog } from "@/shared/domain/triggers";

import { type AgentFormValues } from "./agentFormSchema";
import { agentVariableCatalog } from "./agentVariableCatalog";

/**
 * The `{{ }}` vocabulary the form currently offers, recomputed as the text
 * that declares it is typed.
 *
 * Only the fields a placeholder may appear in are watched, so renaming the
 * agent does not rebuild the catalog.
 */
export function useAgentVariableCatalog(): TriggerTemplateCatalog {
  const [kickoffMessage, goals, variableMeta, passthroughGoals] = useWatch<
    AgentFormValues,
    ["kickoffMessage", "goals", "variableMeta", "passthroughGoals"]
  >({ name: ["kickoffMessage", "goals", "variableMeta", "passthroughGoals"] });

  return React.useMemo(
    () =>
      agentVariableCatalog({
        name: "",
        description: "",
        modelProfile: null,
        kickoffMessage,
        goals,
        skills: [],
        variableMeta,
        passthroughGoals,
        passthroughVariables: [],
      }),
    [kickoffMessage, goals, variableMeta, passthroughGoals],
  );
}
